"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  settings: {
    mimeType: 'application/json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://develop-accounts.idtysandbox.imdserve.com',
    preproduction: 'https://release-accounts.idty.imdserve.com',
    production: 'https://production-accounts.idty.imdserve.com'
  },
  endpoints: {
    claims: {
      endpoint: '/webuseraccountapi/settings'
    },
    account: {
      endpoint: '/webuseraccountapi'
    }
  }
};
exports["default"] = _default;